import React, { FunctionComponent, ReactNode } from "react";

import { bemClassNames } from "@multiweb/reactUtils";
import { AnimationPhase } from "../types";

export type AnimatedOpacityProps = {
    /** Potomek */
    children: ReactNode;
    /** Fáze animace */
    animationPhase: AnimationPhase;
    /** Délka trvání animace */
    animationDurationMs: number;
};

const classNames = bemClassNames("animated-opacity-component");

/**
 * Komponenta slouží pro animování neprůhlednosti (*property* `opacity`) obalované komponenty.
 */
export const AnimatedOpacity: FunctionComponent<AnimatedOpacityProps> = ({
    children,
    animationPhase,
    animationDurationMs,
}) => {
    const startPhase = animationPhase === AnimationPhase.start;

    return (
        <div
            className={classNames()}
            style={{
                opacity: startPhase ? 1 : 0,
                animation: `opacityAnimation ${animationDurationMs}ms ease-in`,
                transition: `all ${animationDurationMs}ms ${startPhase ? "ease-in" : "ease-out"}`,
            }}
        >
            {children}
        </div>
    );
};
